import { render, staticRenderFns } from "./ElegiacCouplet.vue?vue&type=template&id=a9ddf0a6&scoped=true"
import script from "./ElegiacCouplet.vue?vue&type=script&lang=js"
export * from "./ElegiacCouplet.vue?vue&type=script&lang=js"
import style0 from "./ElegiacCouplet.vue?vue&type=style&index=0&id=a9ddf0a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ddf0a6",
  null
  
)

export default component.exports